import { Instance, types } from 'mobx-state-tree'

export const ProfileModuleVersionModel = types.model('ProfileModuleVersionModel', {
    module: types.string,
    version: types.string,
})

export type ProfileModuleVersion = Instance<typeof ProfileModuleVersionModel>
